// Lista reală de analize și prețuri MEDAS (actualizat 12.05.2025)
export const LAB_TESTS = [
  { name: "1,25 dihidroxi vitamina D", price: "180 lei" },
  { name: "17 OH Progesteron", price: "69 lei" },
  { name: "25-hidroxi vitamina D", price: "125 lei" },
  { name: "Acizi biliari totali", price: "152 lei" },
  { name: "Ac anti adenovirus IgG", price: "88 lei" },
  { name: "Ac anti adenovirus IgM", price: "88 lei" },
  { name: "Ac anti ADN dublu catenar", price: "126 lei" },
  { name: "Ac anti Aspergillus fumigatus IgG", price: "100 lei" },
  { name: "Ac anti beta-2 glicoproteina IgG, IgM, IgA", price: "192 lei" },
  { name: "Ac anti Candida albicans IgG", price: "113 lei" },
  { name: "Ac anti cardiolipina IgG, IgM, IgA", price: "200 lei" },
  { name: "Ac anti CCP", price: "92 lei" },
  { name: "Ac anti Difteria", price: "120 lei" },
  { name: "Ac anti Endomisium IgA", price: "153 lei" },
  { name: "Ac anti Endomisium IgG", price: "223 lei" },
  { name: "Ac anti EBV VCA IgG", price: "78 lei" },
  { name: "Ac anti EBV VCA IgM", price: "78 lei" },
  { name: "Ac anti EBV EBNA IgG", price: "100 lei" },
  { name: "Ac anti Echinococcus granulosus IgG", price: "161 lei" },
  { name: "Ac anti Fosfolipidici IgG", price: "92 lei" },
  { name: "Ac anti Fosfolipidici IgM", price: "92 lei" },
  { name: "Ac anti gliadina IgA", price: "94 lei" },
  { name: "Ac anti gliadina IgG", price: "94 lei" },
  { name: "Ac anti HbC IgM", price: "78 lei" },
  { name: "Ac anti LKM1", price: "109 lei" },
  { name: "Ac anti Leptospira IgG", price: "153 lei" },
  { name: "Ac anti Leptospira IgM", price: "153 lei" },
  { name: "Ac anti mitocondrii – depistaj (AMA)", price: "132 lei" },
  { name: "Ac anti receptor TSH (LATS) (TRAb)", price: "110 lei" },
  { name: "Ac anti receptor acetilcolina", price: "218 lei" },
  { name: "Ac anti SS-A (Ro)", price: "119 lei" },
  { name: "Ac anti SCL", price: "106 lei" },
  { name: "Ac anti SLA", price: "171 lei" },
  { name: "Ac anti tiroglobulina", price: "55 lei" },
  { name: "Ac anti Tripsina", price: "72 lei" },
  { name: "Ac anti transglutaminaza tisulara IgA / IgG", price: "193 lei" },
  { name: "Ac anti virus Coxsackie B IgG", price: "140 lei" },
  { name: "Ac anti virus Coxsackie B IgM", price: "133 lei" },
  { name: "Ac anti virus Delta (HDV) totali", price: "90 lei" },
  { name: "Ac anti virus hepatic Delta IgM (HDV)", price: "114 lei" },
  { name: "Ac anti virus hepatic E IgG", price: "150 lei" },
  { name: "Ac anti virus hepatic E IgM", price: "150 lei" },
  { name: "Ac anti virus Influenza A IgA", price: "127 lei" },
  { name: "Ac anti virus Influenza A IgG", price: "133 lei" },
  { name: "Ac anti virus Influenza B IgA", price: "133 lei" },
  { name: "Ac anti virus Influenza B IgG", price: "103 lei" },
  { name: "Ac anti virus rujeolic IgG", price: "100 lei" },
  { name: "Ac anti virus rujeolic IgM", price: "100 lei" },
  { name: "Ac anti virus sincitial respirator IgA", price: "107 lei" },
  { name: "Ac anti virus sincitial respirator IgG", price: "107 lei" },
  { name: "Ac anti virus urlian IgG", price: "127 lei" },
  { name: "Ac anti virus urlian IgM", price: "133 lei" },
  { name: "Ac anti virus varicelo-zosterian IgG", price: "100 lei" },
  { name: "Ac anti virus varicelo-zosterian IgM", price: "127 lei" },
  { name: "Ac antinucleari", price: "100 lei" },
  { name: "Ac antinucleari depistaj + titrare", price: "100 lei" },
  { name: "Ac Borrelia b IgG", price: "90 lei" },
  { name: "Ac Borrelia b IgM", price: "92 lei" },
  { name: "Ac Helicobacter Pylori - cantitativ", price: "51 lei" },
  { name: "Acid metilmalonic", price: "402 lei" },
  { name: "Acid palmitic", price: "489 lei" },
  { name: "Acid uric", price: "16 lei" },
  { name: "Acid vanilmandelic urinar", price: "116 lei" },
  { name: "Acid valproic (Depakina)", price: "112 lei" },
  { name: "ACTH", price: "84 lei" },
  { name: "Albumina sidef", price: "6 lei" },
  { name: "Adenovirus / Rotavirus (Coproantigen)", price: "90 lei" },
  { name: "ADN Human Papilloma Virus (HPV) detectie + genotipare", price: "396 lei" },
  { name: "AFP", price: "102 lei" },
  { name: "Ag Chlamydia Trachomatis", price: "141 lei" },
  { name: "Ag Giardia lamblia", price: "56 lei" },
  { name: "Ag Hbs - cantitativ", price: "140 lei" },
  { name: "Ag Helicobacter Pylori - fecal", price: "90 lei" },
  { name: "AgHbe", price: "72 lei" },
  { name: "Ag Hbs calitativ", price: "55 lei" },
  { name: "Albumina urinara / Creatinina urinara (Raport)", price: "60 lei" },
  { name: "Albumina serica", price: "20 lei" },
  { name: "Aldosteron", price: "180 lei" },
  { name: "Aluminiu in ser", price: "157 lei" },
  { name: "AMH (hormon mullerian)", price: "234 lei" },
  { name: "Amilaza", price: "20 lei" },
  { name: "Amilazurie", price: "29 lei" },
  { name: "Amiloid A (SAA)", price: "116 lei" },
  { name: "Androstendion seric", price: "160 lei" },
  { name: "Angiotensinconvertaza (ACE)", price: "114 lei" },
  { name: "Apolipoproteina A1", price: "54 lei" },
  { name: "Profil ANA panel 3 blot extins", price: "200 lei" },
  { name: "Profil ANA titrare IgA, IgG, IgM", price: "282 lei" },
  { name: "ANCA", price: "146 lei" },
  { name: "ANCA cANCA", price: "90 lei" },
  { name: "ANCA pANCA", price: "100 lei" },
  { name: "ADN virali hepatita B", price: "365 lei" },
  { name: "ARN virali hepatita C", price: "365 lei" },
  { name: "Anti Chlamidia trachomatis IgG", price: "77 lei" },
  { name: "Anticoagulant lupic", price: "188 lei" },
  { name: "Anti Chlamidia trachomatis IgA", price: "69 lei" },
  { name: "Anti HAV IgM", price: "50 lei" },
  { name: "Anti Hbc total", price: "78 lei" },
  { name: "Anti Hbe", price: "66 lei" },
  { name: "Anti Hbs calitativ", price: "55 lei" },
  { name: "Anti Hbs cantitativ", price: "140 lei" },
  { name: "Anti HCV calitativ", price: "56 lei" },
  { name: "Anti HCV cantitativ", price: "78 lei" },
  { name: "Anti Herpes virus 1/2 IgG", price: "101 lei" },
  { name: "Anti Herpes virus 1/2 IgM", price: "68 lei" },
  { name: "Anti Toxocara canis IgG", price: "70 lei" },
  { name: "Anti TPO", price: "58 lei" },
  { name: "Anti Trichinella spiralis IgG", price: "91 lei" },
  { name: "Anticorpi specifici anti RH", price: "155 lei" },
  { name: "Apolipoproteina B", price: "63 lei" },
  { name: "APTT", price: "28 lei" },
  { name: "ASLO - cantitativ", price: "29 lei" },
  { name: "ASMA", price: "159 lei" },
  { name: "Beta Cross-Laps", price: "128 lei" },
  { name: "Bicarbonat", price: "60 lei" },
  { name: "Bilirubina directa", price: "16 lei" },
  { name: "Bilirubina indirecta", price: "16 lei" },
  { name: "Bilirubina totala", price: "16 lei" },
  { name: "C1 inhibitor esteraza - activitate", price: "123 lei" },
  { name: "CA 125", price: "54 lei" },
  { name: "CA 15-3", price: "58 lei" },
  { name: "CA 19-9", price: "58 lei" },
  { name: "CA 21-1 (CYFRA)", price: "79 lei" },
  { name: "CA 50", price: "264 lei" },
  { name: "CA 72-4", price: "79 lei" },
  { name: "Calcitonina", price: "80 lei" },
  { name: "Calciu ionic seric", price: "19 lei" },
  { name: "Calciu seric total", price: "16 lei" },
  { name: "Calciu urinar", price: "27 lei" },
  { name: "Calcul urinar", price: "222 lei" },
  { name: "Calprotectina cantitativ", price: "189 lei" },
  { name: "Campylobacter Ag (JeJuni)", price: "184 lei" },
  { name: "Capacitatea totala de legare a fierului (CTLF)", price: "35 lei" },
  { name: "Catecolamine in urina", price: "252 lei" },
  { name: "CEA", price: "58 lei" },
  { name: "Ceruloplasmina", price: "67 lei" },
  { name: "Citomegalovirus IgG", price: "73 lei" },
  { name: "Citomegalovirus IgM", price: "73 lei" },
  { name: "CK - MB", price: "34 lei" },
  { name: "Clor seric", price: "22 lei" },
  { name: "Clostridium Difficile – toxina A&B, GDH", price: "130 lei" },
  { name: "Colesterol seric total", price: "16 lei" },
  { name: "Colinesteraza", price: "35 lei" },
  { name: "Coombs direct / test antiglobulinic direct", price: "48 lei" },
  { name: "Complement C3", price: "35 lei" },
  { name: "Complement C4", price: "35 lei" },
  { name: "Complexe Imuno Circulante (CIC)", price: "166 lei" },
  { name: "Coprocultura", price: "58 lei" },
  { name: "Cortizol", price: "56 lei" },
  { name: "Creatinina Clearance", price: "34 lei" },
  { name: "Creatinina serica", price: "16 lei" },
  { name: "Creatinina urinara (24 ore)", price: "26 lei" },
  { name: "Creatinina urinara spot", price: "26 lei" },
  { name: "CreatinFosfoKinaza (CK)", price: "26 lei" },
  { name: "Crom seric", price: "144 lei" },
  { name: "Cupru seric", price: "131 lei" },
  { name: "Cupru urinar", price: "96 lei" },
  { name: "DAO (diaminoxidaza)", price: "198 lei" },
  { name: "D-Dimeri", price: "78 lei" },
  { name: "Determinare grup sanguin ABO", price: "35 lei" },
  { name: "Determinare grup sanguin RH", price: "40 lei" },
  { name: "DHEA", price: "94 lei" },
  { name: "DHEA-S", price: "66 lei" },
  { name: "Digoxina", price: "72 lei" },
  { name: "Droguri in urina", price: "127 lei" },
  { name: "Dublu test fara interpretare", price: "180 lei" },
  { name: "Dublu test cu interpretare", price: "200 lei" },
  { name: "Dublu test fara interpretare Brahms-Kryptor", price: "300 lei" },
  { name: "Elastaza pancreatica", price: "186 lei" },
  { name: "Electroforeza hemoglobinei", price: "77 lei" },
  { name: "Electroforeza proteinelor serice", price: "45 lei" },
  { name: "Electroforeza lipoproteinelor", price: "222 lei" },
  { name: "Estradiol", price: "55 lei" },
  { name: "Examen Babeș-Papanicolau", price: "55 lei" },
  { name: "Examen citologic al frotiului sangvin", price: "45 lei" },
  { name: "Examen citologic al urinei", price: "139 lei" },
  { name: "Examen complet de urina", price: "34 lei" },
  { name: "Examen coproparazitologic", price: "25 lei" },
  { name: "Factor Reumatoid - cantitativ", price: "32 lei" },
  { name: "Feritina", price: "50 lei" },
  { name: "Fibrinogen", price: "30 lei" },
  { name: "Folati - vitamina B9", price: "54 lei" },
  { name: "Fosfataza acida", price: "75 lei" },
  { name: "Fosfataza alcalina", price: "20 lei" },
  { name: "Fosfataza alcalina osoasa", price: "240 lei" },
  { name: "Fosfor", price: "18 lei" },
  { name: "Fluor in ser", price: "105 lei" },
  { name: "Free Beta HCG", price: "97 lei" },
  { name: "FSH", price: "50 lei" },
  { name: "FT3", price: "45 lei" },
  { name: "FT4", price: "45 lei" },
  { name: "GGT", price: "16 lei" },
  { name: "Glicemie", price: "16 lei" },
  { name: "Glucoza urinara", price: "23 lei" },
  { name: "HCG total gravida", price: "66 lei" },
  { name: "HCG total (marker tumoral)", price: "66 lei" },
  { name: "HDL Colesterol", price: "25 lei" },
  { name: "HE4", price: "132 lei" },
  { name: "HOMA indice", price: "80 lei" },
  { name: "Hormon de crestere (hGH)", price: "126 lei" },
  { name: "Hemoglobina glicozilata (HbA1c)", price: "45 lei" },
  { name: "Hemoleucograma completa", price: "35 lei" },
  { name: "Hemoragii oculte cantitativ", price: "68 lei" },
  { name: "HLA B27", price: "312 lei" },
  { name: "Homocisteina", price: "145 lei" },
  { name: "Imunofixare IgD, IgE, Kappa + Lambda", price: "198 lei" },
  { name: "IgA seric", price: "35 lei" },
  { name: "IgE - cantitativ", price: "47 lei" },
  { name: "IgE specific alergeni recombinati praf de casa", price: "114 lei" },
  { name: "IgE specific la Paracetamol", price: "120 lei" },
  { name: "IgE specific la Ambrozie", price: "100 lei" },
  { name: "IgE specific la amestec de mucegai", price: "100 lei" },
  { name: "IgE specific la Cacao", price: "100 lei" },
  { name: "IgE specific la Dermatophagoides Pteronyssinus", price: "108 lei" },
  { name: "IgE specific la Dermatophagoides Farinae", price: "100 lei" },
  { name: "IgE specific la epiteliu si par de pisica", price: "100 lei" },
  { name: "IgE specific la Gluten", price: "100 lei" },
  { name: "IgE specific la Polen de Timoftica", price: "108 lei" },
  { name: "IgG seric", price: "35 lei" },
  { name: "IgM seric", price: "35 lei" },
  { name: "Imunoelectroforeza", price: "172 lei" },
  { name: "Insulina", price: "66 lei" },
  { name: "Interleukina 6", price: "246 lei" },
  { name: "Intoleranta la lactoza", price: "348 lei" },
  { name: "Intact PTH (parathormon)", price: "59 lei" },
  { name: "Iod seric", price: "302 lei" },
  { name: "Lanturi usoare Lambda", price: "185 lei" },
  { name: "Lanturi usoare Kappa", price: "185 lei" },
  { name: "LDH", price: "22 lei" },
  { name: "LDL Colesterol", price: "25 lei" },
  { name: "LDL oxidat", price: "222 lei" },
  { name: "LH", price: "50 lei" },
  { name: "Lipaza", price: "32 lei" },
  { name: "Lipoproteina A", price: "113 lei" },
  { name: "Lipide totale", price: "23 lei" },
  { name: "Listeria monocytogenes serologie", price: "125 lei" },
  { name: "Litiu seric", price: "37 lei" },
  { name: "Magneziu", price: "16 lei" },
  { name: "Metanefrine si Normetanefrine in urina", price: "276 lei" },
  { name: "Metanefrine si Normetanefrine libere plasmatice", price: "276 lei" },
  { name: "Microalbuminurie spot", price: "39 lei" },
  { name: "Microalbuminurie 24h", price: "45 lei" },
  { name: "Mercur in sange", price: "155 lei" },
  { name: "Morfologie eritrocitara", price: "35 lei" },
  { name: "Nichel in ser", price: "210 lei" },
  { name: "Noradrenalina", price: "246 lei" },
  { name: "Norovirus", price: "110 lei" },
  { name: "NT-proBNP", price: "160 lei" },
  { name: "NSE marker pulmonar", price: "78 lei" },
  { name: "Osmolalitate serica", price: "117 lei" },
  { name: "Osmolalitate urinara", price: "117 lei" },
  { name: "Oxalat in urina", price: "167 lei" },
  { name: "Coenzima Q10", price: "282 lei" },
  { name: "Osteocalcina", price: "84 lei" },
  { name: "Panel alergeni ALEX 2", price: "806 lei" },
  { name: "Panel alergeni alimentari (35 alergeni)", price: "276 lei" },
  { name: "Panel alergeni respiratori (27 alergeni)", price: "311 lei" },
  { name: "Panel mixt de alergeni (28 alergeni)", price: "264 lei" },
  { name: "PAPP-A", price: "108 lei" },
  { name: "Peptidul C", price: "102 lei" },
  { name: "Potasiu", price: "25 lei" },
  { name: "Porfirine totale", price: "264 lei" },
  { name: "Potasiu urinar", price: "25 lei" },
  { name: "Profil genetic al riscului de trombofilie complet", price: "800 lei" },
  { name: "Progesteron", price: "54 lei" },
  { name: "Procalcitonina", price: "140 lei" },
  { name: "Prolactina", price: "55 lei" },
  { name: "Proteina C Reactiva (CRP) - cantitativ", price: "29 lei" },
  { name: "Proteina C Reactiva - high sensitive (hsCRP)", price: "82 lei" },
  { name: "Proteina cationica a eozinofilelor (ECP)", price: "162 lei" },
  { name: "Proteine totale", price: "16 lei" },
  { name: "Proteine urinare (24 ore)", price: "29 lei" },
  { name: "PSA", price: "53 lei" },
  { name: "PSA free", price: "55 lei" },
  { name: "Raport renina / aldosteron", price: "426 lei" },
  { name: "Renina plasmatica", price: "265 lei" },
  { name: "Rata de filtrare glomerulara - eGFR", price: "23 lei" },
  { name: "Reticulocite", price: "42 lei" },
  { name: "ROMA index (scor)", price: "170 lei" },
  { name: "Rotavirus / Adenovirus (coproantigen)", price: "90 lei" },
  { name: "Rubella IgG", price: "66 lei" },
  { name: "Rubella IgM", price: "66 lei" },
  { name: "Proteina S100", price: "180 lei" },
  { name: "Saturatia transferinei", price: "57 lei" },
  { name: "Proba de digestie", price: "51 lei" },
  { name: "SCC A", price: "84 lei" },
  { name: "SHBG (sex hormon binding globulin)", price: "71 lei" },
  { name: "Sediment Hamburger (ADIS)", price: "35 lei" },
  { name: "Seleniu seric", price: "172 lei" },
  { name: "Serotonina in plasma", price: "186 lei" },
  { name: "Serotonina serica", price: "192 lei" },
  { name: "Sideremie", price: "16 lei" },
  { name: "Sodiu", price: "25 lei" },
  { name: "T3", price: "54 lei" },
  { name: "T4", price: "54 lei" },
  { name: "Testare HIV anticorpi", price: "55 lei" },
  { name: "Testosteron", price: "46 lei" },
  { name: "Testosteron liber", price: "72 lei" },
  { name: "TGO (AST)", price: "16 lei" },
  { name: "TGP (ALT)", price: "16 lei" },
  { name: "Triptaza", price: "207 lei" },
  { name: "Timp Quick + INR", price: "23 lei" },
  { name: "Tiroglobulina", price: "67 lei" },
  { name: "Toxoplasma IgG", price: "66 lei" },
  { name: "Toxoplasma IgM", price: "66 lei" },
  { name: "TPHA", price: "35 lei" },
  { name: "Transferina", price: "40 lei" },
  { name: "Trigliceride", price: "16 lei" },
  { name: "Triplu test fara interpretare", price: "186 lei" },
  { name: "Triplu test cu interpretare", price: "204 lei" },
  { name: "Troponina I hipersensibila", price: "83 lei" },
  { name: "TSH", price: "45 lei" },
  { name: "Uree serica", price: "16 lei" },
  { name: "Uree urinara", price: "27 lei" },
  { name: "Urocultura", price: "55 lei" },
  { name: "VDRL / RPR", price: "22 lei" },
  { name: "VLDL Colesterol", price: "19 lei" },
  { name: "Vitamina B1", price: "220 lei" },
  { name: "Vitamina B2", price: "222 lei" },
  { name: "Vitamina B6", price: "205 lei" },
  { name: "Vitamina B12", price: "55 lei" },
  { name: "Vitamina C", price: "264 lei" },
  { name: "VSH", price: "16 lei" },
  { name: "Zinc seric", price: "96 lei" },
];

// Filtre rapide pe categorii (heuristici după denumire)
export const LAB_FILTERS = [
  { id: "toate", label: "Toate analizele", match: () => true },
  {
    id: "uzuale", label: "Uzuale",
    match: (n) => ["Glicemie", "Hemoleucograma completa", "TSH", "Colesterol seric total", "Trigliceride",
      "TGO (AST)", "TGP (ALT)", "Uree serica", "Creatinina serica", "Acid uric", "Examen complet de urina",
      "VSH", "Sideremie", "Feritina", "Magneziu", "Calciu seric total", "Fibrinogen", "Timp Quick + INR",
      "HDL Colesterol", "LDL Colesterol", "GGT", "Proteina C Reactiva (CRP) - cantitativ"].includes(n),
  },
  { id: "hormoni", label: "Hormoni & Tiroidă", match: (n) => /TSH|FT3|FT4|\bT3\b|\bT4\b|FSH|\bLH\b|Estradiol|Progesteron|Testosteron|Prolactina|Cortizol|Insulina|DHEA|ACTH|Aldosteron|AMH|hormon|Anti TPO|Tiroglobulina|SHBG|Peptidul C|Renina/i.test(n) },
  { id: "vitamine", label: "Vitamine & Minerale", match: (n) => /Vitamina|Folati|Sideremie|Feritina|Calciu|Magneziu|Zinc|Cupru|Seleniu|Fosfor|Fier|Iod|Nichel|Crom/i.test(n) },
  { id: "tumorali", label: "Markeri tumorali", match: (n) => /CA 1|CA 2|CA 5|CA 7|CEA|AFP|\bPSA\b|HE4|ROMA|NSE|SCC|HCG total \(marker/i.test(n) },
  { id: "infectii", label: "Infecții & Serologie", match: (n) => /IgG|IgM|IgA|virus|Ac anti|Toxoplasma|Rubella|HIV|HCV|Hbs|Hbe|Hbc|HAV|Helicobacter|Borrelia|VDRL|TPHA|Chlamidia|Chlamydia|Citomegalovirus|Herpes|Giardia|Coprocultura|Urocultura/i.test(n) },
  { id: "urina", label: "Urină", match: (n) => /urin|Microalbuminurie|Urocultura|Examen complet de urina|Sediment Hamburger|Droguri in urina|Glucoza urinara|Amilazurie/i.test(n) },
];
